export default {
  api_key: "3a4f82b9d06d94a4f8efa1a28a105f4f",
};
